export default "__VITE_ASSET__CS9f8Xse__"